<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch6" epub:type="chapter" role="doc-chapter">
<header>
<p class="SP"> </p>
<h1 class="CN" id="ch6"><span aria-label="39" id="pg_39" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch6" title="Link target outside of Sample">JOHNSON SPACE CENTER, ISS CONTROL CENTER, HOUSTON, TEXAS</span></span></h1>
</header>
<p class="CO">Scott glanced at the clock. Only four minutes had passed since he’d cut the live feed from the ISS to the public media. They’re probably screaming bloody murder right now, and wondering if they’d really seen that on the ISS, some 250 miles above the Earth. Scott bet that some TV execs might think the NASA feed had been hacked by jokers.</p>
<p class="TX">He ran his fingers over the touchscreen and set up a link with the Administrator’s office at NASA Headquarters back in Washington, D.C. The phone was picked up on the first ring.</p>
<p class="TX">“Mike Mott.”</p>
<p class="TX">“Mini, Basher,” Scott said, using their old fighter pilot handles. His nickname had stuck with him, as had Mini’s. An ex-Marine Corps pilot, Mini Mott was just barely tall enough to qualify for flight training. And even though he had failed to enter the <span aria-label="40" id="pg_40" role="doc-pagebreak">astronaut corps, he had been picked by Patricia Simone to be her executive officer at NASA Headquarters. His buzz-cut thatch of light brown hair was well-known throughout the agency. Small but deadly was the word about Mini Mott.</span></p>
<p class="TX">“We just heard,” said Mini. “Trying to get ahold of the Administrator now. How about you? Do you have contact with the station? How are our folks?”</p>
<p class="TX">“Don’t know. We’re out of communication. All links and relays to the ISS are down.”</p>
<p class="TX">“What about NASA TV?”</p>
<p class="TX">“I severed the live feed to the public right after Vasilev’s murder.”</p>
<p class="TX">“Good call.”</p>
<p class="TX">“Someone on the ISS took down everything else; probably Farid.”</p>
<p class="TX">“So we don’t know if anyone else was killed, right?”</p>
<p class="TX">“Roger that.” Scott pulled in a deep breath, trying to calm down. “Where’s the Administrator?”</p>
<p class="TX">“Scheduled to be in a cabinet meeting, briefing the cabinet on the implications of the cut in our budget.”</p>
<p class="TX">“Crappy timing.”</p>
<p class="TX">“Deaths are crappy timing. We’re trying to pull her out now and get the word to her, but the White House staffers are being their usual pricks.”</p>
<p class="TX">Scott’s mind raced. “I’ll stay on the line if you need me. We’re doing everything we can to get back in contact with the station.”</p>
<p class="TX">“Well tell everyone to try harder—” Suddenly it sounded as if Mini was holding a hand over the speaker, muffling it. Seconds passed, then, “Basher, we’re patching you in to the cabinet meeting. One of the President’s aides just whispered the news to him and all hell’s breaking loose. You’ll be going over the speakers to <span aria-label="41" id="pg_41" role="doc-pagebreak">the President’s cabinet. Tell them what you saw, what the status is, and what you’re doing to help. Can you handle it?”</span></p>
<p class="TX">“Copy that,” Scott said, leaning back in his chair. He kept his eyes glued to the monitors at the front of the room displaying the status of the ISS’s systems. He may not be able to communicate with the ISS, but from here he’d be instantly able to relay any changes in the ISS, from the onboard sensors to even a change in altitude.</p>
<p class="TX">He blinked. <i>Change in altitude.</i> Now why did that cross his mind?</p>
<p class="TX">“Basher, Mini. Stand by one. We’re patching you through to the White House communications agency.”</p>
<p class="TX">The line chirped and suddenly sounded tinny, as though its digital signal was somehow being analyzed and encrypted.</p>
<p class="TX">“Lieutenant Colonel Robinson?”</p>
<p class="TX">Scott straightened in his chair. “Speaking.”</p>
<p class="TX">“Sir, the President of the United States.”</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?fb87f6f6